import {
  CHANGE_ENTITY,
  CHANGE_LEVEL,
  CHANGE_STAGE,
  RESET_STATE,
  SIGN_UP_REQUEST,
  SIGN_UP_SUCCESS,
  SIGN_UP_FAILED,
  OPEN_EXIT_MODAL,
  CLOSE_EXIT_MODAL,
  OPEN_PIX_MODAL,
  CLOSE_PIX_MODAL,
  UPDATE_ONBOARDING_STATUS
} from '../actions/types';

import {
  onChangeEntity,
  onChangeLevel,
  onChangeStage,
  onSignupFailed,
  onSignupSuccess,
  onSignupRequest,
  onOpenExitModal,
  onCloseExitModal,
  onOpenPixModal,
  onClosePixModal,
  onUpdateOnboardingStatus
} from './reducers';

const initialState = {
  currentLevel: 'profile',
  entity: 'personal',
  personalEntity: {
    stage: 'basicInfos'
  },
  legalEntity: {
    stage: 'basicInfos'
  },
  exitModal: {
    isOpen: false,
    destination: ''
  },
  pixModal: {
    isOpen: false
  },
  onboarding: null,
  administradoraId: null,
  successOutcome: null,
  signupLoading: false,
  signupError: undefined
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case CHANGE_ENTITY:
      return onChangeEntity(state, payload);
    case CHANGE_LEVEL:
      return onChangeLevel(state, payload);
    case CHANGE_STAGE:
      return onChangeStage(state, payload);
    case RESET_STATE:
      return initialState;
    case SIGN_UP_REQUEST:
      return onSignupRequest(state);
    case SIGN_UP_SUCCESS:
      return onSignupSuccess(state, payload);
    case SIGN_UP_FAILED:
      return onSignupFailed(state, payload);
    case OPEN_EXIT_MODAL:
      return onOpenExitModal(state, payload);
    case CLOSE_EXIT_MODAL:
      return onCloseExitModal(state);
    case OPEN_PIX_MODAL:
      return onOpenPixModal(state);
    case CLOSE_PIX_MODAL:
      return onClosePixModal(state, payload);
    case UPDATE_ONBOARDING_STATUS:
      return onUpdateOnboardingStatus(state, payload);
    default:
      return state;
  }
};
